var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4008 22.6614C31.7938 23.3677 32 24.1626 32 24.9709C32 27.5944 29.8732 29.7212 27.2496 29.7212H4.75123C3.94295 29.7212 3.14803 29.515 2.44171 29.122C0.149085 27.8465 -0.67544 24.954 0.600077 22.6613L11.8494 2.44171C12.2797 1.66823 12.9176 1.03037 13.6911 0.600051C15.9837 -0.67544 18.8763 0.149117 20.1518 2.44175L31.4008 22.6614ZM14.3876 7.85843H17.5833L17.318 19.0147H14.6529L14.3876 7.85843ZM14.076 22.9833C14.076 24.0909 14.8259 24.8177 15.9911 24.8177C17.1564 24.8177 17.9063 24.0909 17.9063 22.9833C17.9063 21.8643 17.1564 21.1374 15.9911 21.1374C14.8259 21.1374 14.076 21.8643 14.076 22.9833Z",
    fill: "#F2C94C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon_warning.f779b726.svg";
export { ForwardRef as ReactComponent };